import React, { useEffect } from 'react';
import { useSEO } from '../hooks/useSEO';
import Navbar from './Navbar';
import Hero from './Hero';
import Features from './Features';
import CTA from './CTA';
import Footer from './Footer';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      '@id': 'https://www.tailclinic.gr/#organization',
      name: 'TailClinic',
      url: 'https://www.tailclinic.gr',
      logo: 'https://www.tailclinic.gr/favicon.png',
      description: 'Λογισμικό διαχείρισης κτηνιατρείου για κτηνιάτρους στην Ελλάδα.',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer support',
        url: 'https://www.tailclinic.gr/contact',
        availableLanguage: 'Greek',
      },
    },
    {
      '@type': 'SoftwareApplication',
      '@id': 'https://www.tailclinic.gr/#software',
      name: 'TailClinic',
      url: 'https://www.tailclinic.gr',
      applicationCategory: 'BusinessApplication',
      operatingSystem: 'Web',
      inLanguage: 'el',
      description:
        'Ολοκληρωμένο λογισμικό διαχείρισης κτηνιατρείου. Διαχείριση ραντεβού, πελατών, ιατρικών ιστορικών, αποθήκης και προσωπικού.',
      offers: {
        '@type': 'Offer',
        url: 'https://www.tailclinic.gr/pricing',
        priceCurrency: 'EUR',
        availability: 'https://schema.org/InStock',
      },
      publisher: {
        '@id': 'https://www.tailclinic.gr/#organization',
      },
      featureList: [
        'Διαχείριση ραντεβού κτηνιατρείου',
        'Ιατρικά ιστορικά ζώων',
        'Διαχείριση πελατών',
        'Online κράτηση ραντεβού',
        'Διαχείριση αποθήκης',
        'Διαχείριση προσωπικού και βαρδιών',
      ],
    },
  ],
};

const LandingPage = () => {
  useSEO({
    title: 'TailClinic - Ολοκληρωμένη Διαχείριση Κτηνιατρείου',
    description:
      'Η σύγχρονη πλατφόρμα για κτηνιάτρους. Κλείστε ραντεβού, διαχειριστείτε πελάτες, ιατρικά ιστορικά και οργανώστε το ιατρείο σας εύκολα και γρήγορα.',
    canonical: 'https://www.tailclinic.gr/',
  });

  useEffect(() => {
    let script = document.querySelector('script[data-seo="jsonld"]');
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo', 'jsonld');
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(jsonLd);
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#1A202C',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{ position: 'absolute', left: 0, right: 0, top: '4rem', bottom: 0, background: 'radial-gradient(800px 800px at 10% -10%, rgba(16,185,129,0.15), transparent), radial-gradient(800px 800px at 110% 10%, rgba(59,130,246,0.08), transparent)', pointerEvents: 'none' }} />
      <Navbar />
      <Hero />
      <Features />
      <Footer />
      {/* Future sections can be added here */}
    </div>
  );
};

export default LandingPage;
